var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTimesSolid = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 223.07 223.07",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.08,111.54,219,33.62a14,14,0,0,0,0-19.7l-9.85-9.84a13.92,13.92,0,0,0-19.69,0L111.54,82,33.62,4.08a13.93,13.93,0,0,0-19.7,0L4.08,13.92a13.93,13.93,0,0,0,0,19.7L82,111.54,4.08,189.46a13.92,13.92,0,0,0,0,19.69L13.92,219a14,14,0,0,0,19.7,0l77.92-77.92L189.46,219a13.94,13.94,0,0,0,19.69,0l9.85-9.85a13.94,13.94,0,0,0,0-19.69Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTimesSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/times-solid.5ce6f0ea.svg";
export { ForwardRef as ReactComponent };